// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.

export const selectStudio = (state) => state.studio.studio;
export const selectStudios = (state) => state.studio.studios;
export const selectStudioUuid = (state) => state.studio.studio?.studio_uuid;
